<template>
  <article
    :class="['mt-5', { 'container-fluid': !isMobile, 'mx-n3': isMobile }]"
  >
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col">
          <SectionTitle :title="title" :icon="icon" reverse />
        </div>
      </div>
      <div class="container-fluid bg-light-gray py-3">
        <div class="row">
          <div
            v-if="!disabled"
            :class="[
              'col-12 col-md-4',
              {
                'divider-horizontal pb-3': !isMobile,
              },
            ]"
          >
            <div class="row">
              <div :class="['col-12 col-md-8']">
                <ValidationProvider
                  ref="itemToAddValidator"
                  v-slot="{ errors }"
                  name="Escuela"
                  :rules="`${items.length == 0 ? 'required' : ''}`"
                >
                  <CustomDropDown
                    v-model="itemToAdd"
                    :options="availableSelectionList"
                    :disabled="disabled"
                    :clearable="false"
                    :label="optionsTitle"
                    :fieldkey="optionsKeyProp"
                    :fieldname="optionsLabelProp"
                    :custom-error-msg="noSelectionErrorMesage"
                    :error="errors[0]"
                    placeholder="Seleccione"
                    class="height-fixed"
                  />
                </ValidationProvider>
              </div>
              <div class="col-12 col-md-4 d-flex align-self-end">
                <ActionButton
                  v-if="!disabled"
                  :class="{ 'btn-block mt-5': isMobile }"
                  text="Añadir"
                  variant="success"
                  i="fas fa-file-plus"
                  class="add-tran"
                  @click="handleSubmit(add)"
                />
              </div>
            </div>
          </div>
          <div :class="['col-12', { 'col-md-8': !disabled }]">
            <div :class="{ 'divider-vertical pt-1 pb-4': isMobile }" />
            <div
              :class="{
                'ml-3 chips-container': !isMobile,
                'mt-4': isMobile,
              }"
            >
              <CustomChipsGroup
                :selected-items="items"
                :disabled="disabled"
                :title="chipsTitle"
                :no-background="true"
                :no-wrap="true"
                :object-text="chipsKeyText"
                :on-item-deleted="remove"
              />
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </article>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomChipsGroup from 'CustomChipsGroup';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'ItemsSelectionSection',
  components: {
    SectionTitle,
    ActionButton,
    CustomChipsGroup,
    CustomDropDown,
  },
  data() {
    return {
      itemToAdd: null,
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectionList: {
      type: Array,
      default: () => [],
    },
    optionsKeyProp: {
      type: String,
      default: 'id',
    },
    optionsLabelProp: {
      type: String,
      default: 'name',
    },
    optionsTitle: {
      type: String,
      default: 'Áreas de Asistencia:',
    },
    icon: {
      type: String,
      default: 'fas fa-list',
    },
    title: {
      type: String,
      default: 'Áreas de Asistencia',
    },
    chipsTitle: {
      type: String,
      default: 'Áreas Seleccionadas',
    },
    chipsKeyText: {
      type: String,
      default: 'name',
    },
    noSelectionErrorMesage: {
      type: String,
      default: 'Favor añadir al menos un área de asistencia.',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model() {
      return this.value;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    availableSelectionList() {
      const selectableItems = this.selectionList.filter(
        (itemToSelect) =>
          !this.items.some(
            (itemSelected) =>
              itemSelected[this.optionsKeyProp] ==
              itemToSelect[this.optionsKeyProp]
          )
      );
      return selectableItems.sort((a, b) => {
        return a[this.optionsKeyProp] - b[this.optionsKeyProp];
      });
    },
  },
  methods: {
    add() {
      this.items.push(this.itemToAdd);
      this.itemToAdd = null;
      this.$refs.itemToAddValidator.reset();
    },
    remove(item) {
      const index = this.items.findIndex(
        (e) => e[this.optionsKeyProp] === item[this.optionsKeyProp]
      );
      this.items.splice(index, 1);
      this.$refs.itemToAddValidator.reset();
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
  height: 100%;
}
.divider-vertical {
  border-bottom: 1px solid #e2e2e2;
}
::v-deep .chips-container {
  padding-top: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  min-height: 89px !important;
  .mt-3 {
    margin-top: 0 !important;
  }
  .bold {
    margin-bottom: 0 !important;
    font-weight: 400 !important;
  }
  .label.label-default.chips {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }
}
::v-deep .student-search-alert-error {
  height: 0;
}
</style>
